import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgDeleteResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgDeleteResponseDTO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly data: RoomBrandBgDeleteResponse) {
    JsonSchemaValidator.assert(RoomBrandBgDeleteResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgDeleteResponse {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
